import React from "react";
import Section from "./Section";
import SectionHeader from "./SectionHeader";
import SectionButton from "./SectionButton";
import "./HeroSection.scss"

function HeroSection(props) {
  return (
    <Section
      color={props.color}
      size={props.size}
      backgroundImage={props.backgroundImage}
      backgroundImageOpacity={props.backgroundImageOpacity}
    >
      <div className="container input-center">
        <SectionHeader
          title={props.title}
          subtitle={props.subtitle}
          size={1}
          spaced={true}
          className="has-text-centered"
        ></SectionHeader>
        {!props.showInput &&
          <SectionHeader
            title="You're signed up!"
            size={1}
            spaced={true}
            className="has-text-centered"
          ></SectionHeader>
        }
        {
          props.showInput &&
          <input
          className="SignupInput input is-medium"
          ref={props.phoneInputRef}
          type="text"
          placeholder="Phone #"
        ></input>}
        {props.showInput &&
        <input
          className="SignupInput input is-medium"
          ref={props.zipInputRef}
          type="text"
          placeholder="Zip"
        ></input>
      }
{ props.showInput &&
        <div className="buttons is-centered">
          <SectionButton
            parentColor={props.color}
            size="medium"
            onClick={props.buttonOnClick}
          >
            {props.buttonText}
          </SectionButton>
        </div>
      }
      </div>
    </Section>
  );
}

export default HeroSection;
